import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Switch, Route } from 'react-router-dom';
import routes from '../../routers';
import action from "../../actions";
import { Icon } from 'antd';
import Images from '../../constants/Images';
import i18n from "../../constants/initLng";
import { LoadingComponent } from './common/component/Index';

class Login extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
        }
    }

    async componentDidMount() {
        this._isMounted = true;
    
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.checkAuthorize();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.authState.action) {
            if (nextProps.authState.action === "FAIL") {
                this.setState({
                    googleCaptchaResponse: undefined
                });
            }
        }
    }

    onChange = (e) => {
        var target = e.target;
        var name = target.name;
        var value = target.value;
        this.setState({
            [name]: value
        });
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.login();
        return false;
    };

    login() {
        this.props.onLogin(this.state);
    }

    checkAuthorize() {
        const { authState } = this.props;
        if (!authState.logged) {
            this.props.onLogin({ autoLogin: true });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { authState } = this.props;
        const loading = authState.logging || authState.authenticating;
        return (
            <LoadingComponent
                spinning={authState.authenticating && !authState.logged}
                size="large"
                style={{ textAlign: 'center', minHeight: '50vw', maxHeight: '100%' }}>
                <section>
                    <div className="login-register">
                        {!authState.authenticating && (
                            <Fragment>
                                <div className="login-bg">
                                    <img src={Images.login_bg} />
                                </div>
                                <div className="loginMain">
                                    <div className="blur-bg">
                                        <img src={Images.login_bg} />
                                        <div className="blur-bg-opacity"></div>
                                    </div>
                                    <div className="text-center" style={{ padding: '20px' }}>
                                        <img src={Images.logo} className="img-fluid" />
                                    </div>
                                    {/*<form className="form-horizontal form-material" method={`POST`} onSubmit={this.onSubmit}>*/}
                                    {/*    <fieldset disabled={loading}>*/}
                                    {/*<div className="form-group">*/}
                                    {/*    <Input type="text"*/}
                                    {/*        className="form-control"*/}
                                    {/*        autoComplete="off"*/}
                                    {/*        name={`username`}*/}
                                    {/*        disabled={loading}*/}
                                    {/*        onChange={this.onChange}*/}
                                    {/*        value={username}*/}
                                    {/*        required*/}
                                    {/*        placeholder={i18n.t(`item.login.email`)}*/}
                                    {/*        suffix={<Icon type="user" />} />*/}
                                    {/*</div>*/}
                                    {/*<div className="form-group">*/}
                                    {/*    <Input type="password"*/}
                                    {/*        className="form-control"*/}
                                    {/*        autoComplete="off"*/}
                                    {/*        name={`password`}*/}
                                    {/*        disabled={loading}*/}
                                    {/*        onChange={this.onChange}*/}
                                    {/*        value={password} required*/}
                                    {/*        placeholder={i18n.t(`item.login.password`)}*/}
                                    {/*        suffix={<Icon type="lock" />} />*/}
                                    {/*</div>*/}
                                    <button type="submit" className="btn btn-primary block full-width btn-login" disabled={loading} onClick={() => this.props.onLogin()}>{i18n.t(`item.login.login`)} {loading && <Icon type="sync" spin />}</button>
                                    {/*    </fieldset>*/}
                                    {/*</form>*/}
                                </div>
                            </Fragment>
                        )}
                    </div>
                </section>
            </LoadingComponent>
        )
    }
}

const mapStateToProps = state => {
    return {
        // categories: state.reducerCategory,
        authState: state.authReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogin: (params) => {
            dispatch(action.loginAction(params))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
